


























import { Component, Vue } from 'vue-property-decorator';
import { CurrentFamily, Family } from '@/types';
import { VButton, VHeader, VInput } from '@/components';
import router from '@/router';

@Component({
  components: {
    VButton,
    VHeader,
    VInput
  }
})
export default class QuitFamily extends Vue {
  family: Family | null = null;
  familyNameInputValue = '';

  async mounted() {
    this.family = await CurrentFamily.instance.getCurrentFamily();
  }

  async handleQuit() {
    await CurrentFamily.instance.quit();
    router.back();
  }

  get familyNameInputMatch() {
    return this.familyNameInputValue === this.family?.name;
  }
}
